//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PersonalCard from '~/components/Card/PersonalCard';
import { fileDownload } from '~/utils';
export default {
  name: 'UploadFiles',
  components: { PersonalCard },
  props: {
    title: { type: String, default: '上傳檔案' },
    getApi: { type: String, default: '' },
    updateApi: { type: String, default: '' },
    deleteApi: { type: String, default: '' },
  },
  data() {
    return {
      resumeFiles: [],
    };
  },
  methods: {
    handleDownload(file) {
      fileDownload(file.url, file.name);
    },
    beforeUploadUserFile(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isLt2M) {
        this.$message.error('檔案大小不可超過2MB!');
      }
      return isLt2M;
    },
    handleRemove(file) {
      if (file.status === 'ready') {
        return true;
      }

      if (!this.deleteApi) return;

      this.$confirm(`確定移除 ${file.name}？`)
        .then(() => {
          try {
            let id = file.response !== undefined ? file.response.id : file.id;
            this.$api(this.deleteApi, { id }).then(() => {
              this.loadUserFiles();
              this.$message.success('删除成功');
            });
          } catch (e) {
            this.$message.error('移除檔案失敗');
          }
        })
        .catch(() => {
          this.$message.info('已取消删除');
        });
      return false;
    },
    onUploadUserFile(event) {
      const { file } = event;

      if (!this.updateApi) return;

      this.$api(this.updateApi, { file }, data => {
        if (data) {
          this.$message.success('上傳檔案成功');
        } else {
          this.$message.error('上傳檔案失敗');
        }
        this.loadUserFiles();
      });
    },
    loadUserFiles() {
      if (!this.getApi) return;

      this.$api(this.getApi).then(data => {
        this.resumeFiles = data.map(e => {
          return {
            id: e.id,
            name: e.fileName,
            url: e.fileUrl,
          };
        });
      });
    },
  },
  mounted() {
    this.loadUserFiles();
  },
};
